import { Box, Typography } from '@mui/material';
import React from 'react';
import { classes } from './styles';

type Props = {
  title: string;
  children: React.ReactNode;
};

const RadioLabel = ({ children, title }: Props) => {
  return (
    <Box sx={classes.radioLabelContainer}>
      <Typography sx={classes.radioLabelTitle}>{title}</Typography>
      <Typography sx={classes.radioLabelBody}>{children}</Typography>
    </Box>
  );
};

export default RadioLabel;
